<template>
  <div class="clause-wrapper">
    <div class="clause-body">
      <p style="text-align: center; line-height: 16px">
        <span style="font-size: 14px"
          ><strong
            ><span style="font-size: 14px"
              >天津华盛保险经纪有限公司</span
            ></strong
          ></span
        >
      </p>
      <p style="text-align: center; line-height: 16px">
        <span style="font-size: 14px"
          ><strong
            ><span style="font-size: 14px">客户告知书</span></strong
          ></span
        >
      </p>
      <p>
        <span style="font-size: 14px">尊敬的客户：</span>
      </p>
      <p style="text-indent: 47px">
        <span style="font-size: 14px"
          >感谢您委托我公司代为办理保险业务。本公司是基于投保人的利益，为投保人与保险公司订立保险合同提供中介服务的保险专业中介机构。为了保护你的合法权益，按照《保险经纪人监管规定》的要求，本公司应履行客户告知义务，现将有关事项告知如下，请仔细阅读。公司基本情况</span
        >
      </p>
      <p style="margin-left: 0; text-indent: 38px">
        <span style="font-size: 14px"
          >一、&nbsp;总公名称：天津华盛保险经纪有限公司</span
        >
      </p>
      <p>
        <span style="font-size: 14px"
          >住所：天津自贸试验区（中心商务区）旷世国际大厦2栋1410；许可证名称及机构编码：《保险中介<span
            style="font-size: 14px; font-family: 仿宋"
            >许可证》</span
          >
          260942000000800；批准日期：2011年03月09日（有效期至：2023年3月19日）<span
            style="font-size: 14px"
            ><span style="font-family: 仿宋"
              >；<span style="font-size: 14px"
                >业务范围：在全国区域内（港、澳、台除外）为投保人拟定投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；中国保监会批准的其他业务；经营区域：全国（港、澳、台除外）；联系方式：</span
              ></span
            >010-50822713。</span
          ></span
        >
      </p>
      <p style="margin-left: 0; text-indent: 38px">
        <span style="font-size: 14px"
          >二、&nbsp;根据保险监管部门的规定，只有持《保险经纪从业人员执业证书》的人员方可从事保险经纪业务，您可要求本公司业务人员出示《保险经纪从业人员执业证书》，并可通过登录中国保监会保险中介监管信息系统查询业务人员持证情况（</span
        ><a
          href="http://iir.circ.gov.cn"
          style="
            color: rgb(19, 110, 194);
            text-decoration: underline;
            font-size: 14px;
          "
          ><span
            style="
              color: rgb(19, 110, 194);
              text-decoration: underline;
              font-size: 14px;
            "
            >http://iir.circ.gov.cn</span
          ></a
        ><span style="font-size: 14px">）。</span>
      </p>
      <p style="margin-left: 0; text-indent: 40px">
        <span style="font-size: 14px"
          >三、&nbsp;请仔细阅读保险条款，保险产品的广告、公告、彩页等宣传资料不属于保险合同的组成部分。请重点关注保险责任、责任免除或者除外责任、犹豫期后解除合同的损失、投保人和被保险人权利义务、免赔额或免赔率的计算、等待期等内容，并可要求本公司服务人员对上述内容进行详细讲解。</span
        >
      </p>
      <p style="margin-left: 0; text-indent: 38px">
        <span style="font-size: 14px"
          >四、&nbsp;请向本公司客服人员了解《中华人民共和国保险法》等法律法规对于索赔时效、保险公司理赔时限、合同中止与失效、未成年人投保限额等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄或职业不真实等情形导致的法律后果。</span
        >
      </p>
      <p style="text-indent: 38px">
        <span style="font-size: 14px"
          >五、根据《中华人民共和国保险法》的规定，保险经纪机构因过错给投保人、被保险人造成损失的，依法承担赔偿责任。</span
        >
      </p>
      <p>
        <span style="font-size: 14px"
          >五、本公司已按《保险经纪人监管规定》缴存保证金/投保职业责任保险。</span
        >
      </p>
      <p style="text-indent: 40px">
        <span style="font-size: 14px"
          >六、本公司为您与保险公司订立保险合同提供保险经纪服务，并依据与保险公司签订的协议依法收取经纪费。</span
        >
      </p>
      <p style="text-indent: 38px">
        <span style="font-size: 14px"
          >七、本公司及公司高级管理人员与经纪业务相关的保险公司、其它中介机构不存在关联关系。</span
        >
      </p>
      <p style="text-indent: 38px">
        <span style="font-size: 14px"
          >八、如果您发现本公司服务人员存在误导行为及其他损害您合法权益的行为，请注意保留书面证据或其他证据，可向本公司投诉九、如果您发现本公司从业人员存在误导行为及其他损害您合法权益的行为，请注意保留书面证据或其他证据，可向本公司投诉。</span
        >
      </p>
      <p style="text-indent: 38px">
        <span style="font-size: 14px">九、纠纷解决联系方式：</span>
      </p>
      <p>
        <span style="font-size: 14px">公司客服电话：400-000-7535</span>
      </p>
      <p>
        <span style="font-size: 14px">公司投诉电话：010-50822713</span>
      </p>
      <p>
        <span style="font-size: 14px"
          >中国银行保险监督管理委员会消费者投诉维权电话：12378</span
        >
      </p>
      <p style="text-indent: 40px">
        <span style="font-size: 14px">十、投保人义务确认</span>
      </p>
      <p>
        <span style="font-size: 14px"
          >您已按照您投保的保险产品要求进行如实告知，如出现因未如实告知情况发生的任何违反《中华人民共和国保险法》第十六条法规的，投保人自行承担违反义务的后果。投保人已阅知如下的第十六条法规内容，并承诺已如实告知。</span
        >
      </p>
      <p style="text-indent: 60px">
        <span style="color: rgb(255, 0, 0); font-size: 14px"
          >《中华人民共和国保险法》第十六条订立保险合同，保险人就保险标的或者被保险人的有关情况提出询问的，投保人应当如实告知。投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险人决定是否同意承保或者提高保险费率的，保险人有权解除合同。前款规定的合同解除权，自保险人知道有解除事由之日起，超过三十日不行使而消灭。自合同成立之日起超过二年的，保险人不得解除合同；发生保险事故的，保险人应当承担赔偿或者给付保险金的责任。投保人故意不履行如实告知义务的，保险人对于合同解除前发生的保险事故，不承担赔偿或者给付保险金的责任，并不退还保险费。投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于合同解除前发生的保险事故，不承担赔偿或者给付保险金的责任，但应当退还保险费。保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应当承担赔偿或者给付保险金的责任。保险事故是指保险合同约定的保险责任范围内的事故。</span
        >
      </p>
      <p class="MsoNormal">
        <span style="font-size: 14px">&nbsp;</span>
      </p>
      <div class="close-btn" @click="closeClause">关闭</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerPage",
  methods: {
    closeClause() {
      this.$router.back(-1);
    },
  },
};
</script>

<style scoped lang="scss">
.clause-wrapper {
  overflow-y: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;

  .clause-body {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 80vh;
    color: #333;
    background-color: #fff;
    z-index: 9999;
    -webkit-transition: 300ms all;
    transition: 300ms all;
    overflow: auto;
    padding: 10vw 0 20vw;

    .header {
      height: 13.33vw;
      line-height: 13.33vw;
      font-size: 4.8vw;
      font-weight: bold;
      border-bottom: 0.27vw solid #f5f5f9;
      text-align: center;
    }

    .content {
      height: 60vh;
      padding: 2.67vw 5vw;
      overflow: auto;
      text-align: justify;

      .title {
        text-align: center;
        font-size: 4.8vw;
        font-weight: bold;
        margin: 2vw 0;
      }
    }

    .close-btn {
      width: 100%;
      height: 12vw;
      line-height: 12vw;
      text-align: center;
      color: #ffffff;
      background: #3385ff;
      position: fixed;
      bottom: 0;
    }
  }
}
</style>
